import { useStoreConfiguration } from '../../../store/configuration/configuration';
import type { WindowWika } from '../../../types/window';
import { post } from '../../../xhr/post';

type Results = string[];

export const getResults = async (word: string | undefined) => {
  if (!word || word.length < 2) {
    return [] as Results;
  }

  const _window = window as unknown as WindowWika;
  const disableExternalDocuments = _window.disableExternalDocuments;
  const storeConfiguration = useStoreConfiguration();
  const computedCountry =
    storeConfiguration?.caasConfig?.searchCountry ??
    _window?.searchCountry ??
    storeConfiguration?.caasConfig?.currentCountry ??
    _window?.currentCountry ??
    storeConfiguration?.caasConfig?.locale;

  if (!storeConfiguration?.caasConfig) {
    return [] as Results;
  }

  const suggest = await post<{
    suggest: {
      ['prefix-suggest']: Array<{ options: Array<{ text: string }> }>;
    };
  }>(
    `${
      _window.isStorybook ? 'http://localhost:9000' : storeConfiguration.config?.pt_search_base_url // TODO remove localhost
    }${storeConfiguration.config?.caas_suggestSearchUrl}`,
    {
      // global
      container: storeConfiguration.config?.pt_search_container,
      shopContainer: storeConfiguration.config?.pt_search_shop_container,
      country: computedCountry,
      language: storeConfiguration.caasConfig.searchCountry
        ? storeConfiguration.caasConfig.language.replace('EN-US', 'EN')
        : storeConfiguration.caasConfig.language,
      disableExternalDocuments,
      instance: storeConfiguration.caasConfig.instance || _window.instance,
      // payload
      word,
    },
  );

  if (!suggest) {
    return [];
  }

  const results = suggest.suggest['prefix-suggest'].flatMap((item) =>
    item.options.map((option) => option.text),
  );

  return results;
};
